import { createContext } from "react";
import type { YAxisStore } from "../YAxisProvider.types";

const YAxisStoreContext = createContext<YAxisStore | undefined>(undefined);
YAxisStoreContext.displayName = "YAxisStoreContext";

export default YAxisStoreContext;
